import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-person',
  templateUrl: './person.component.svg',
})
export class PersonComponent extends MedrecordIcon {
  viewHeight = 18;
  viewWidth = 18;
}
